import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { productDetailTabs } from '@/features/products/components/product-detail-tabs'
import { ProductDetailView } from '@/features/products/products'
import { hasGrant } from '@/lib/me'

const positivePage = z
  .preprocess((value) => {
    const page = Number(value)
    return Number.isInteger(page) && page > 0 ? page : undefined
  }, z.number().int().positive())
  .optional()

export const Route = createFileRoute('/_authenticated/products/$productId/')({
  validateSearch: z.object({
    salesPage: positivePage,
    purchasesPage: positivePage,
    tab: z.enum(productDetailTabs).optional().catch(undefined),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'product.view')) {
      throw redirect({ to: '/products' })
    }
  },
  component: ProductDetailView,
})
